<template>
	<b-progress
		id='loader'
		class='rounded-0 position-absolute shadow'
		:class='{ show: numPendingOperations }'
		:value='100'
		striped
		animated
		variant='precision'
	/><!-- /.progress -->
</template>

<script>
export default {
	name: `Loader`,
	data: () => ({ numPendingOperations: 0 }),
	mounted () {
		/* this allows us to notice when actions happen in vuex. normally the request() method hooks
		    enquie() and dequeue(), but $root isn't accessible from within vuex, so instead we assume that
		    if something asynchronous is happening (a vuex action), we're loading.
		    https://vuex.vuejs.org/api/#subscribeaction */
		this.$store
			.subscribeAction({ before: () => this.numPendingOperations++, after: () => this.numPendingOperations-- });
	}
};
</script>

<style lang='scss' scoped>
#loader {
	height: .5rem;
	top: -10px;
	transition: .5s ease-in-out;
	z-index: 10;

	&:not(.show) {
		width: 0;
		opacity: 0;
		right: 0;
	}
	&.show {
		width: 100%;
		left: 0;
	}
}
</style>